<template>
  <div class="medsos">
    <div class="medsos__wrapper">
      <div class="medsos__wrapper__header">
        <p class="title">Campaign editor</p>
        <p class="description">Set your facebook or instagram campaign details</p>
        <adx-breadcrumb class="breadcrumb" :items="items"/>
      </div>
      <div class="medsos__wrapper__form">
        <!-- Iklan Page -->
        <div v-if="pageState == 1" class="medsos__wrapper__form__iklan">
          <div class="medsos__wrapper__form__iklan__url section">
            <adx-input :label="`Campaign Name *`" :value.sync="model.name" :error.sync="error.name" :validation="['NotEmpty', 'MaxLength:50']" :ref="dataRef1.name"/>
          </div>
          <div class="medsos__wrapper__form__iklan__url section">
            <adx-input :label="`Website URL *`" :value.sync="model.url" :error.sync="error.url" :validation="['NotEmpty', 'Url']" :ref="dataRef1.url"/>
          </div>
          <div class="medsos__wrapper__form__iklan__goal section">
            <p class="section-title">Set Campaign Goal</p>
            <div class="medsos__wrapper__form__iklan__goal__radio-wrapper">
              <div class="radio-group">
                <div class="radio">
                  <input type="radio" id="one" value="wt" v-model="model.campaignGoal"/>
                  <label class="subhead" for="one">Web Traffic</label>
                </div>
                <p class="description">Get the right people to visit your website</p>
              </div>
              <div class="radio-group">
                <div class="radio">
                  <input type="radio" id="two" value="aw" v-model="model.campaignGoal"/>
                  <label class="subhead" for="two">Awareness</label>
                </div>
                <p class="description">Reach a broad audience and build awareness</p>
              </div>
            </div>
          </div>
          <div class="medsos__wrapper__form__iklan__company section">
            <p class="section-title">Company Information</p>
            <div class="row1"><adx-input :ref="dataRef1.companyName" :label="`Company Name *`" :value.sync="model.companyName" :error.sync="error.companyName" :validation="['NotEmpty', 'MaxLength:150']"/></div>
            <div class="row1"><adx-input :ref="dataRef1.companyPhone" :label="`Company Phone Number *`" :value.sync="model.companyPhone" :error.sync="error.companyPhone" :validation="['NotEmpty', 'Phone', 'MaxLength:16']" type="number"/></div>
            <div class="row1"><adx-input :ref="dataRef1.companyAddress" :label="`Company Address *`" :value.sync="model.companyAddress" :error.sync="error.companyAddress" :validation="['NotEmpty']"/></div>
            <div class="row2">
              <adx-input :label="`City`" :value.sync="model.companyCity" :validation="['MaxLength:50']"/>
              <adx-input :label="`Province`" :value.sync="model.companyProvince" :validation="['MaxLength:50']"/>
            </div>
          </div>
        </div>
        <!-- Target Page -->
        <div v-if="pageState == 2" class="medsos__wrapper__form__target">
          <div class="medsos__wrapper__form__target__platform section">
            <p class="section-title">Choose Platform</p>
            <div class="checkboxes">
              <div class="checkbox-wrapper">
                <adx-checkbox :label="`Facebook`" :valueLabel="`fb`" :value.sync="model.fb" :error.sync="error.platform" :ref="dataRef2.platform"/>
              </div>
              <div class="checkbox-wrapper">
                <adx-checkbox :label="`Instagram`" :valueLabel="`ig`" :value.sync="model.ig" :error.sync="error.platform" :ref="dataRef2.platform"/>
              </div>
            </div>
            <div v-if="error.platform" class="error-message">Please select at least one option.</div>
          </div>
          <div class="medsos__wrapper__form__target__placement section">
            <p class="section-title">Choose Placement</p>
            <div class="checkboxes">
              <div class="checkbox-wrapper">
                <adx-checkbox :label="`Post`" :valueLabel="`po`" :value.sync="model.post" :error.sync="error.placement" :ref="dataRef2.placement"/>
              </div>
              <div class="checkbox-wrapper">
                <adx-checkbox :label="`Video`" :valueLabel="`vi`" :value.sync="model.video" :error.sync="error.placement" :ref="dataRef2.placement"/>
              </div>
              <div class="checkbox-wrapper">
                <adx-checkbox :label="`Stories`" :valueLabel="`st`" :value.sync="model.stories" :error.sync="error.placement" :ref="dataRef2.placement"/>
              </div>
            </div>
            <div v-if="error.placement" class="error-message">Please select at least one option.</div>
          </div>
          <div class="medsos__wrapper__form__target__location section">
            <p class="section-title">Select location to target</p>
            <div class="radio-group">
              <div class="radio">
                <input type="radio" id="one" value="Indonesia" v-model="model.locationTarget"/>
                <label class="subhead" for="one">Indonesia</label>
              </div>
            </div>
            <div class="radio-group">
              <div class="radio">
                <input type="radio" id="two" v-model="model.locationTarget"/>
                <label class="subhead" for="two">Specific Location</label>
              </div>
            </div>
            <div v-if="!model.locationTarget">
              <adx-input :label="`Insert specific location`" :value.sync="model.locationTargetCustom" :error.sync="error.location" ref="locationRef" :validation="['NotEmpty']"/>
            </div>
          </div>
          <div class="medsos__wrapper__form__target__schedules section">
            <p class="section-title">Schedules</p>
            <div class="medsos__wrapper__form__target__schedules__row">
              <adx-select-dropdown :label="`Period of Campaign`" :options="campaignPeriodOptions" class="dropdown" :value.sync="model.period" :error.sync="error.period" :validation="['NotEmpty']" />
              <div class="calendar">
                <v-date-picker
                  v-model='model.startDate'
                  :min-date='aWeekAfter'
                  :popoverVisibility="'focus'"
                  :theme-styles='themeStyles'
                  class='date-picker'>
                  <div class="field"
                    slot-scope='{ inputValue, updateValue }'
                  >
                    <input
                      class="date-picker-input"
                      type='text'
                      required
                      :value='inputValue'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                      <label class="subhead calendar-label">Start Date</label>
                  </div>
                </v-date-picker>
              </div>
            </div>
          </div>
          <div class="medsos__wrapper__form__target__audience section">
            <p class="section-title">Target Audience</p>
            <div class="medsos__wrapper__form__target__audience__row">
              <adx-select-dropdown :label="`Gender`" :options="genderDropdown" class="dropdown" :value.sync="model.audienceGender"/>
            </div>
            <div class="medsos__wrapper__form__target__audience__row">
              <adx-select-dropdown :label="`Age`" :options="ageDropdown" class="dropdown" :value.sync="model.audienceAgeFrom" @click.stop="validateAge" :error.sync="error.audienceAgeFrom" :ref="dataRef2.audienceAgeFrom"/>
              <p>to</p>
              <adx-select-dropdown :label="`Age`" :options="ageDropdown" class="dropdown" :value.sync="model.audienceAgeTo" @click.stop="validateAge" :error.sync="error.audienceAgeTo" :ref="dataRef2.audienceAgeTo"/>
            </div>
          </div>
          <div class="medsos__wrapper__form__target__interest section">
            <p class="section-title">Interest</p>
            <adx-select-dropdown :label="`Select your interest`" :options="interestDropdown" class="dropdown" :value.sync="model.interest"/>
          </div>
          <div class="medsos__wrapper__form__target__social section">
            <p class="section-title">Social Detail</p>
            <div class="medsos__wrapper__form__target__social__row">
              <adx-input :label="`Your Facebook account`" :value.sync="model.fbDetail" :error.sync="error.fbDetail" :ref="dataRef2.fbDetail"/>
              <adx-input :label="`Your Instagram account`" :value.sync="model.igDetail"/>
            </div>
            <div class="medsos__wrapper__form__target__social__row1">
              <p v-if="!model.imageName">Upload profile picture</p>
              <p v-else>{{model.imageName}}</p>
              <input type="file" accept="image/*" @change="profileImage" ref="fileUpload" style="display: none;">
              <button class="btn-small secondary" @click="launchFilePicker">Upload File</button>
            </div>
            <p v-if="error.avatar" style="color: red;">{{error.avatar}}</p>
          </div>
          <div class="medsos__wrapper__form__target__creative section">
            <p class="section-title">Creative File</p>
            <div class="medsos__wrapper__form__target__creative__wrapper" :ref="dataRef2.creativeFile" >
              <div v-for="(container, index) in listImage" :key="index" class="medsos__wrapper__form__target__creative__wrapper__default item">
                <div class="medsos__wrapper__form__target__creative__wrapper__default__button">
                  <i class="icon-clear" @click="removeImage(index)"></i>
                </div>
                <input type="file" accept="image/*" @change="creativeImage" ref="fileUpload1" style="display: none;">
                <div class="medsos__wrapper__form__target__creative__wrapper__default__image">
                  <img v-if="!model.creativeImageDisplay[index]" :src="`/img/notfound/img-placeholder-landscape@2x.png`" alt="">
                  <img v-else :src="model.creativeImageDisplay[index]" alt="">
                </div>
                <p class="title">Upload images</p>
                <p class="description">Recomended resolution 1920x 1080</p>
              </div>
              <div :class="['medsos__wrapper__form__target__creative__wrapper__add item', error.creativeFile ? 'warning' : '']" @click="launchFilePickerAdd">
                <input type="file" accept="image/*" @change="creativeImageAdd" ref="fileUpload2" style="display: none;">
                <img :src="`/img/adxicon/ic-add.png`" alt="">
                <p>Add more image</p>
              </div>
            </div>
            <div v-if="error.creativeFile" class="error-message">You can’t leave this creative file empty</div>
          </div>
        </div>
        <!-- Budget Page -->
        <div v-if="pageState == 3" class="medsos__wrapper__form__budget">
          <div class="medsos__wrapper__form__budget__campaign section">
            <p class="section-title">Set your campaign budget</p>
            <adx-select-dropdown :label="`Campaign Budget`" :options="budgetDropdown" class="dropdown" :value.sync="model.budget"/>
          </div>
          <div class="medsos__wrapper__form__budget__promo section">
            <div class="medsos__wrapper__form__budget__promo__header">
              <span class="strong subhead">Promo Code</span>
            </div>
            <div v-if="!isPromoCodeValid" class="medsos__wrapper__form__budget__promo__fields">
              <adx-input :button="`Use`" :label="`Input Promo Code`" :error.sync="promoCodeError" :value.sync="promoCode" @buttonClicked="useVoucher" :upperCase="true"/>
            </div>
            <div v-else class="medsos__wrapper__form__budget__promo__fields">
              <div if class="medsos__wrapper__form__budget__promo__fields__dialog">
                <div class="medsos__wrapper__form__budget__promo__fields__dialog__button">
                  <i class="adx-ic_close" @click="unuseVoucher"></i>
                </div>
                <div class="medsos__wrapper__form__budget__promo__fields__dialog__header">
                  <span>Kode Promo: </span>
                  <span class="code">{{promoCode}}</span>
                </div>
                <div class="medsos__wrapper__form__budget__promo__fields__dialog__description">
                  <span>
                    Congrats! you get discount - {{discount | formatMoney}} for this transaction
                  </span>
                </div>
              </div>
              <span v-if="promoCodeError" class="medsos__wrapper__form__budget__promo__error"> {{promoCodeError}} </span>
            </div>
            <div class="payment__clear-both"></div>
          </div> 
          <div v-if="promoNominal" class="medsos__wrapper__form__budget__promo section">
            <div class="medsos__wrapper__form__budget__promo__header">
              <span class="strong subhead">Total Price : {{ discountedPrice | formatMoney }}</span>
            </div>
            <p>*This is price you need to pay after discount</p>
          </div>
          <div class="medsos__wrapper__form__budget__description section">
            <p class="section-title">Ad Description</p>
            <adx-input :label="`Headline (max 30 characters) *`" :value.sync="model.headline" :validation="['NotEmpty', 'MaxLength: 30']" :error.sync="error.headline" :ref="dataRef3.headline"/>
            <adx-textarea :label="`Description (max 90 characters) *`" :value.sync="model.description" :validation="['NotEmpty', 'MaxLength: 90']" :error.sync="error.description" :ref="dataRef3.description"/>
          </div>
          <div class="medsos__wrapper__form__budget__preview section">
            <p class="section-title">Ad Preview</p>
            <div class="medsos__wrapper__form__budget__preview__media">
              <div class="medsos__wrapper__form__budget__preview__media__wrapper" v-for="(image, index) in model.creativeImageDisplay" :key="index">
                <div class="medsos__wrapper__form__budget__preview__media__wrapper__item" >
                  <img :src="image" alt="">
                  <div class="medsos__wrapper__form__budget__preview__media__wrapper__item__row">
                    <div class="left">
                      <p class="text">{{ model.url }}</p>
                      <p class="title">{{ model.headline }}</p>
                      <p class="text">{{ model.description }}</p>
                    </div>
                    <div class="right"><button class="btn-small secondary">Learn More</button></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sms__wrapper__form__budget__notes section">
            <p class="section-title">Additional Notes and Comments</p>
            <adx-textarea :label="`Your message max 200 characters`" :value.sync="model.notes" :validation="['MaxLength:200']"/>
          </div>
        </div>
        <div class="medsos__wrapper__form__buttons">
          <button v-if="pageState != 1" class="btn-large secondary" @click.stop="prev" :disabled="isSubmitting">Previous</button>
          <button v-if="pageState < 3" class="btn-large primary" @click.stop="next">Continue</button>
          <button v-else class="btn-large primary" @click.stop="submit" :disabled="isSubmitting">Submit<adx-loading-circle class="loading" v-if="isSubmitting" slot="loading" /></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Input from '@/components/Form/Input'
import Checkbox from '@/components/Form/Checkbox'
import SelectDropdown from '@/components/Form/SelectDropdown'
import Textarea from '@/components/Form/TextArea'
import LoadingCircle from '@/components/Loading/Secondary-white'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import moment from 'moment';
import calendar from 'v-calendar'
import { formatShortDate } from '@/lib/util'
import obj2fd from 'obj2fd'

export default {
  name: 'adx-digitaladvertising-medsos',
  components: {
    'adx-breadcrumb': Breadcrumb,
    'adx-input': Input,
    'adx-checkbox': Checkbox,
    'adx-select-dropdown': SelectDropdown,
    'adx-textarea': Textarea,
    'adx-loading-circle': LoadingCircle,
  },
  props: {
    
  },
  data() {
    return {
      coba: null,
      pageState: 1,
      containerUpload: [],
      imageData: null,
      isSubmitting: false,
      model: {
        name: '',
        url: '',
        campaignGoal: 'wt',
        companyName: '',
        companyPhone: '',
        companyAddress: '',
        companyCity: '',
        companyProvince: '',
        platform: [],
        fb: ['fb'],
        ig: [],
        placement: ['po'],
        post: ['po'],
        video: [],
        stories: [],
        locationTarget: 'Indonesia',
        locationTargetCustom: '',
        period: '1 week',
        startDate: null,
        audienceGender: 1,
        audienceAgeFrom: 16,
        audienceAgeTo: 35,
        interest: 'Business and industry',
        fbDetail: '',
        igDetail: '',
        placeholderImage: "/img/notfound/img-placeholder-landscape@2x.png",
        imageName: null,
        imageData: null,
        creativeImageName: [],
        creativeImageData: [],
        creativeImageDisplay: [],
        creativeFile: [
          {
            
          },
        ],
        budget: 250000,
        headline: '',
        description: '',
        notes: ''
      },
      error: {
        name: '',
        url: '',
        companyName: '',
        companyPhone: '',
        companyAddress: '',
        platform: '',
        placement: '',
        fbDetail: '',
        creativeFile: '',
        location: '',
        audienceAgeFrom: '',
        audienceAgeTo: '',
        headline: '',
        description: '',
      },
      dataRef1: {
        name: 'name',
        url: 'url',
        companyName: 'companyName',
        companyPhone: 'companyPhone',
        companyAddress: 'companyAddress',
      },
      dataRef2: {
        platform: 'platform',
        placement: 'placement',
        fbDetail: 'fbDetail',
        creativeFile: 'creativeFile',
        audienceAgeFrom: 'audienceAgeFrom',
        audienceAgeTo: 'audienceAgeTo'
      },
      dataRef3: {
        headline: 'headline',
        description: 'description',
      },
      campaignPeriodOptions: [
        {
          label: `1 week`,
          value: `1 week`
        },
        {
          label: `2 weeks`,
          value: `2 weeks`
        },
        {
          label: `1 month`,
          value: `1 month`
        },
        {
          label: `2 months`,
          value: `2 months`
        },
        {
          label: `3 months`,
          value: `3 months`
        },
      ],
      periodDate: new Date(),
      items: [
        {
          'id': 0,
          'title': '1. Iklan',
          'isCurrent': true
        },
        {
          'id': 1,
          'title': '2. Target',
          'isCurrent': false
        },
        {
          'id': 2,
          'title': '3. Budget',
          'isCurrent': false
        },
      ],
      radioOptions: [
        {
          label: 'Web Traffic',
          value: 'one',
        },
        {
          label: 'Awareness',
          value: 'two',
        }
      ],
      genderDropdown: [
        {
          label: 'All Gender',
          value: 1
        },
        {
          label: 'Male',
          value: 2
        },
        {
          label: 'Female',
          value: 3
        }
      ],
      ageDropdown: [],
      interestDropdown: [
        {
          label: 'Business and industry',
          value: 'Business and industry'
        },
        {
          label: 'Entertainment',
          value: 'Entertainment'
        },
        {
          label: 'Family and relationships',
          value: 'Family and relationships'
        },
        {
          label: 'Fitness and wellness',
          value: 'Fitness and wellness'
        },
        {
          label: 'Food and drink',
          value: 'Food and drink'
        },
        {
          label: 'Hobbies and activities',
          value: 'Hobbies and activities'
        },
        {
          label: 'Shopping and fashion',
          value: 'Shopping and fashion'
        },
        {
          label: 'Sports and outdoors',
          value: 'Sports and outdoors'
        },
        {
          label: 'Technology',
          value: 'Technology'
        },
      ],
      budgetDropdown: [
        {
          label: '250.000',
          value: 250000
        },
        {
          label: '500.000',
          value: 500000
        },
        {
          label: '1.000.000',
          value: 1000000
        },
        {
          label: '5.000.000',
          value: 5000000
        },
        {
          label: '10.000.000',
          value: 10000000
        },
        {
          label: '15.000.000',
          value: 15000000
        },
        {
          label: '20.000.000',
          value: 20000000
        },
        {
          label: '25.000.000',
          value: 25000000
        },
        {
          label: '30.000.000',
          value: 30000000
        },
      ],
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      isValidationPassed: true,
      platformChoices: [],
      promoCode: '',
      discount: 0,
      promoNominal: 0,
      isPromoCodeValid: false,
      promoCodeError: '',
    }
  },
  computed: {
    aWeekAfter() {
      var aWeekAfter = new Date();
      aWeekAfter.setDate(aWeekAfter.getDate() + 7)
      return aWeekAfter
    },
    listImage() {
      return this.containerUpload
    },
    discountedPrice() {
      var price = this.model.budget - this.promoNominal
      if (price < 0) return 0
      return price
    }
  },
  watch: {
    promoCode: function () {
      this.promoCode = this.promoCode.toUpperCase()
    },
    'model.audienceAgeFrom': function () {
      this.$nextTick(() => {
        this.validateAge()
      });
    },
    'model.audienceAgeTo': function () {
      this.$nextTick(() => {
        this.validateAge()
      });
    },
    'model.fb': function () {
      this.$nextTick(() => {
        this.validateCheckboxes('platform')
      });
    },
    'model.ig': function () {
      this.$nextTick(() => {
        this.validateCheckboxes('platform')
      });
    },
    'model.post': function () {
      this.$nextTick(() => {
        this.validateCheckboxes('placement')
      });
    },
    'model.video': function () {
      this.$nextTick(() => {
        this.validateCheckboxes('placement')
      });
    },
    'model.stories': function () {
      this.$nextTick(() => {
        this.validateCheckboxes('placement')
      });
    },
    'model.creativeImageData': function () {
      this.$nextTick(() => {
        if (this.model.creativeImageData.length) this.error.creativeFile = false
      });
    },
    'model.locationTarget': function () {
      this.$nextTick(() => {
        this.model.locationTargetCustom = ''
      });
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.setAge()
    this.setDateValue()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    removeImage(index) {
      this.model.creativeImageData.splice(index, 1)
      this.containerUpload.splice(index, 1)
      this.model.creativeImageDisplay.splice(index, 1)
    },
    useVoucher() {
      (async () => {
        this.promoCodeError = ''
        this.discount -= this.promoNominal
        let params = {
          voucher_code: this.promoCode
        }
        const response = await api.get(apiV2.checkVoucher, { needToken: true, params: params })
        if (response.status == 200) {
          this.promoNominal = response.data.nominal
          this.discount += response.data.nominal
          // if (this.model.budget <= this.promoNominal) {
          //   this.promoNominal = parseInt(this.model.budget)
          //   this.discount = parseInt(this.model.budget)
          // } 
          // else if (this.totalPrice < 9999 ) {
          //   this.promoCodeError = 'Total price should not be be between Rp 0 and Rp 10.000'
          //   this.loadingMidTrans = true
          // } 
          this.isPromoCodeValid = true
        } else {
          this.isPromoCodeValid = false
          this.promoCodeError = response.data.message
        }
      })();
    },
    unuseVoucher() {
      this.isPromoCodeValid = false
      this.discount -= this.promoNominal
      this.promoNominal = 0
    },
    nextPage() {
      this.items[this.pageState - 1].isCurrent = false
      this.pageState += 1
      this.items[this.pageState - 1].isCurrent = true
    },
    raiseError(page) {
      var validationObj = {}
      if (page == 1) {
        validationObj = this.dataRef1
      } else if (page == 2) {
        validationObj = this.dataRef2
      } else {
        validationObj = this.dataRef3
      }
      for (let key in validationObj) {
        let value = this.$refs[key].value
        let element = ''
        if (this.$refs[key].$el) element = this.$refs[key].$el.firstElementChild

        if (key == 'audienceAgeFrom') {
          value = this.model.audienceAgeFrom
        } else if (key == 'audienceAgeTo') {
          value = this.model.audienceAgeTo
        }

        // Validation for FB 
        if (key == 'fbDetail' && !this.model.fbDetail) {
          this.isValidationPassed = false
          this.error.fbDetail = 'Please input your Facebook account.'
          break
        } else {
          this.isValidationPassed = true
          this.error.fbDetail = false
        }

        // Validation for Creative File
        if (key == 'creativeFile' && !this.model.creativeImageData.length) {
          this.isValidationPassed = false
          this.error.creativeFile = true
          break
        } else {
          this.isValidationPassed = true
          this.error.creativeFile = false
        }

        // Validation for the rest of fields
        if (!value || this.error[key] != false) {
          if (key == 'fbDetail' || key == 'creativeFile') break
          if (element) {
            element.focus()
            element.blur()
          }
          this.isValidationPassed = false
          break
        } else {
          this.isValidationPassed = true
        }
      }
    },
    validate() {
      this.raiseError(this.pageState)
      if (this.isValidationPassed) this.nextPage()
    },
    next() {
      if (this.pageState == 2) {
        // Validation for custom location
        if (!this.model.locationTarget && (!this.model.locationTargetCustom || this.error.location != false)) {
          this.error.location = true
          this.isValidationPassed = false
          let element = this.$refs.locationRef.$el.firstElementChild
          element.focus()
          element.blur()
        } else {
          this.validate()
        }
      } else {
        this.validate()
      }
    },
    prev() {
      if (this.pageState > 1) {
        this.items[this.pageState - 1].isCurrent = false
        this.pageState -= 1
        this.items[this.pageState - 1].isCurrent = true
      }
    },
    submit() {
      this.raiseError(this.pageState)
      if (this.isValidationPassed) {
        (async () => {
          this.isSubmitting = true
          const platforms = [
            {
              name: 'fb',
              detail: ''
            }
          ]
          this.model.platform.map(key => {
            platforms.push({
              name: key,
              detail: ''
            }) 
          })
          platforms.map(plat => {
            if (plat.name == "fb") {
              plat.detail = this.model.fbDetail
            } else {
              plat.detail = this.model.igDetail
            }
          })
          
          let image = new FormData();
          let data = {
            company: {
              name: this.model.companyName,
              mobile: this.model.companyPhone,
              address: this.model.companyAddress,
              city: this.model.companyCity,
              province: this.model.companyProvince
            },
            detail_ads: {
              url: this.model.url,
              campaign_goal: this.model.campaignGoal,
              location: this.model.locationTarget || this.model.locationTargetCustom,
              period: this.model.period,
              start_date: this.model.startDate,
              audience_gender: this.model.audienceGender,
              audience_age_from: this.model.audienceAgeFrom,
              audience_age_to: this.model.audienceAgeTo,
              budget: this.model.budget,
              headline: this.model.headline,
              description: this.model.description
            },
            platform: platforms,
            creative: this.model.creativeImageData,
            social: {
              placement: this.model.placement,
              interest: this.model.interest,
              notes: this.model.notes,
              campaign_name: this.model.name
            },
            promo: {
              code: this.promoCode,
              nominal: this.promoNominal
            }
          }

          const dataImage = {
            detail_file: this.model.imageData
          }

          image = obj2fd(dataImage)

          const response = await api.post(apiV2.sosialMedia, data, { needToken: true })
          const attachImage = await api.patch(apiV2.socialMediaImage(response.data.id), image, { needToken: true })
          if (response.status == 201) {
            this.$notify({
              group: 'saved',
              title: 'Save success',
              text: 'Data successfully saved!',
              type: 'success'
            });
            this.$router.push({name: 'transactiondigitaladvertising'})
          } else {
            this.$notify({
              group: 'saved',
              title: 'Save error',
              text: 'Oops data can not be saved!',
              type: 'danger'
            });
          }
          this.isSubmitting = false
        })();
      }
    },
    setAge() {
      var arr = new Array();
      var j = 0;
      for (var i = 16; i < 65; i++) {
        var age = {
          id: j,
          label: i,
          value: i
        };
        arr.push(age)
        j++;
      }
      this.ageDropdown = arr
    },
    validateAge() {
      if (this.model.audienceAgeFrom > this.model.audienceAgeTo) {
        this.error.audienceAgeFrom = 'Age is not valid.'
        this.error.audienceAgeTo = 'Age is not valid.'
        this.isValidationPassed = false
      } else {
        this.error.audienceAgeFrom = false
        this.error.audienceAgeTo = false
        this.isValidationPassed = true
      }
    },
    validateCheckboxes(opt) {
      switch(opt) {
        case 'platform':
          if (!this.model.fb.length && !this.model.ig.length) {
            this.error.platform = 'Please select at least one option.'
            this.isValidationPassed = false
          } else {
            this.error.platform = false
            this.isValidationPassed = true
          }
          this.model.platform = this.model.fb.concat(this.model.ig)
          break
        case 'placement':
          if (!this.model.post.length && !this.model.video.length && !this.model.stories.length) {
            this.error.placement = 'Please select at least one option.'
            this.isValidationPassed = false
          } else {
            this.error.placement = false
            this.isValidationPassed = true
          }
          this.model.placement = this.model.post.concat(this.model.video, this.model.stories)
          break
      }
    },
    launchFilePicker(){
      this.$refs.fileUpload.click()
    },
    getRefs(index){
      return `fileUpload${index}`
    },
    launchFilePickerMulti(index){
      this.$refs.fileUpload1[index].click()
    },
    launchFilePickerAdd(){
      this.$refs.fileUpload2.click()
    },
    profileImage(event) {

      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateFile(input.files[0])
        if (!validated_data.is_valid) {
          this.error['avatar'] = validated_data.message
        } else {
          reader.readAsDataURL(input.files[0]);
          this.model.imageName = input.files[0].name;
          this.model.imageData = input.files[0];
        }
      }
    },
    creativeImage(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateFile(input.files[0])
        if (!validated_data.is_valid) {
          this.error['avatar'] = validated_data.message
        } else {
          reader.onload = (e) => {
            this.model.creativeImageDisplay.push(e.target.result);
          }
          reader.readAsDataURL(input.files[0]);
          this.model.creativeImageName.push(input.files[0].name);
          this.model.creativeImageData.push(input.files[0]);
        }
      }
    },
    creativeImageAdd() {
      (async () => {
        let input = event.target;
        if (input.files && input.files[0]) {
          let reader = new FileReader();
          let validated_data = this.validateFile(input.files[0])
          if (!validated_data.is_valid) {
            this.error['avatar'] = validated_data.message
          } else {
            reader.onload = (e) => {
              
              
              this.model.creativeImageDisplay.push(e.target.result);
            }
            reader.readAsDataURL(input.files[0]);

            var data = new FormData();

            let object = {
                image: input.files[0]
            }

            data = obj2fd(object)
            
            const responseImage = await api.post(apiV2.creativeImage, data, { needToken: true })
            this.model.creativeImageName.push(input.files[0].name);
            this.model.creativeImageData.push(responseImage.data.id)
            this.containerUpload.push(this.containerUpload.length + 1)
          }
        }
      })();
    },
    validateFile(file) {
      let maxSize = 2000000; // 2 MB
      let data = { is_valid: true }
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
        }
      } else {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
      }
      if (file.size > maxSize) {
        data.is_valid = false
        data.message = `File too large.`
        return data
      }
      const filename = file.name.split('.')[0]
      if (filename.length > 100) {
        data.is_valid = false
        data.message = 'File name is too long. Maximum size 100 character'
        return data
      }

      if (filename.includes('/')) {
        data.is_valid = false
        data.message = 'File name has forbidden character'
        return data
      }
      return data
    },
    addImage(data) {
      this.containerUpload.push(data.length + 1)
    },
    setDateValue() {
      var dateValue = new Date()
      dateValue.setDate(dateValue.getDate() + 7)
      this.model.startDate = dateValue
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.selectDropdown {

    .select {
      .standardInput {
        padding: 16px !important;
      }
    }

    .popup {
      max-height: 300px;
      overflow-y: auto !important;
    }
  }

.small-title {
  font-size: 15px;
  font-weight: normal !important;

  &.current {
    font-weight: bold !important;
  }
}
</style>
